import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class IdentityVerificationComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/identity-verification";
  }

  public static pathWithHash(): string {
    return "statement/:statementId/identity-verification/:hash";
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/identity-verification((\/?#?)|(\/?#.*?))$/;
  }
}
